module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/3-053fdee206c13a919d38eaac14179092.png";